/** biome-ignore-all lint/suspicious/noConsole: <The console is used for logging> */

interface ILoggerOptions {
  level?: LoggerLevel;
}

export enum LoggerLevel {
  Debug = 3,
  Info = 2,
  Error = 1,
  None = 0,
}

export class Logger {
  private level: LoggerLevel = LoggerLevel.Error;

  constructor({ level }: ILoggerOptions = {}) {
    if (level) {
      this.level = level;
    }
  }

  public debug(...args: unknown[]): boolean {
    if (this.level < LoggerLevel.Debug) {
      return false;
    }

    console.log('[DEBUG]', ...args);

    return true;
  }

  public info(...args: unknown[]): boolean {
    if (this.level < LoggerLevel.Info) {
      return false;
    }

    console.log('[DEBUG]', ...args);

    return true;
  }

  public error(...args: unknown[]): boolean {
    if (this.level < LoggerLevel.Error) {
      return false;
    }

    console.log('[ERROR]', ...args);

    return true;
  }
}
